import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { user as selectUser, verifyUser } from '@/slices/user';

export const withAuth =
  (WrappedComponent: React.ComponentType) => (props: any) => {
    const user = useSelector(selectUser);
    const dispatch = useDispatch();

    useEffect(() => {
      if (!user) {
        dispatch(verifyUser());
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch]);

    if (!user) return null;

    return <WrappedComponent {...props} />;
  };
